export default "__VITE_ASSET__CWKYWAlg__"